export enum RecordableStatusName {
    Open = 1,
    Closed = 2
}
